// Storage keys for scroll and pagination state
export const SHOP_SCROLL_KEY = 'shop-scroll-y';
export const SHOP_DISPLAY_COUNT_KEY = 'shop-display-count';
export const SHOP_FILTERS_KEY = 'shop-filters-state';
export const HOME_SCROLL_KEY = 'home-scroll-y';

// Prefix for URL-keyed shop scroll positions
const SHOP_SCROLL_PREFIX = 'shop-scroll-';

export const clearShopScrollState = () => {
  try {
    // Clear legacy keys
    sessionStorage.removeItem(SHOP_SCROLL_KEY);
    sessionStorage.removeItem(SHOP_DISPLAY_COUNT_KEY);
    sessionStorage.removeItem(SHOP_FILTERS_KEY);
    
    // Clear all URL-keyed shop scroll positions
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key?.startsWith(SHOP_SCROLL_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => sessionStorage.removeItem(key));
  } catch {
    // Ignore storage errors
  }
};

export const clearHomeScrollState = () => {
  try {
    sessionStorage.removeItem(HOME_SCROLL_KEY);
  } catch {
    // Ignore storage errors
  }
};
